import { SxProps, Theme } from '@mui/material/styles';

export const titleDpCardCategorySX: SxProps<Theme> = {
    fontSize: {
        xs: 'var(--font-size-small)',
        sm: 'var(--font-size-body)',
    },
    fontWeight: 'bold',
    textAlign: {
        xs: 'center',
        sm: 'start',
    },
    color: 'text.primary',
};

export const descriptionDpCardCategorySX: SxProps<Theme> = {
	fontWeight: 'normal',
	fontSize: {
        sm: 'var(--font-size-small)',
        xs: 'var(--font-size-caption)',
    },
    visibility: {
        xs: 'hidden',
        sm: 'visible',
    },
    height: {
        xs: '0px',
        sm: 'auto',
    },
    textAlign: 'start',
    color: 'text.primary',
};
